import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, first, map } from 'rxjs';
import { onUntouched } from 'src/app/shared/loading-state/loadable';
import { Permission } from '../../../admin/admin.models';
import { getPermissionsList } from '../../../admin/store/general/admin.actions';
import { selectPermissionsList } from '../../../admin/store/general/admin.selectors';
import { selectSelectedCompany, selectUserProfile } from '../../store/auth.selectors';

/**
 * Resolves current user's permissions under the currently selected client account.
 *
 * Requires user and client account to be resolved alongside or prior,
 * otherwise will hang up waiting for them
 */
export const resolvePermissions: ResolveFn<Permission[]> = () => {
  const store = inject(Store);

  return combineLatest([
    store.select(selectPermissionsList),
    store.select(selectSelectedCompany),
    store.select(selectUserProfile),
  ]).pipe(
    // make sure Account and UserProfile are resolved prior or alongside this resolver
    filter(([, account, user]) => !!account && !!user),
    onUntouched(() => store.dispatch(getPermissionsList()), 0),
    first(([permissions]) => !!permissions.value),
    map(([permissions]) => permissions.value!)
  );
};
